import { simpleLookupConfig } from "../../../../records/lookup/config/simpleLookupConfig";
import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

import { machineManufacturerName } from "../../../shared/names";
export { machineManufacturerName as vsObjectName } from "../../../shared/names";

const url = "/api/machines/MachineManufacturer";

export const machineManufacturerLookupConfig = simpleLookupConfig(
  vsLookupManagementServiceProviderName,
  {
    name: machineManufacturerName,
    nameSingular: "Manufacturer",
    url,
  }
);
